import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BrowserCheckService } from '@app/utils/browser-check.service';
import { GtmService } from '@app/shared/services/gtm/gtm.service';
import { COMMON_CONSTANTS } from '@app/shared/constants/common.constants';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  constructor(
    private router: Router,
    private browserCheck: BrowserCheckService,
    private gtmService: GtmService,
  ) {}

  generateToken(): string {
    const accessToken =
      Math.random().toString(36).substring(7) +
      Math.random().toString(36).substring(7);
    if (this.browserCheck.isBrowser()) {
      sessionStorage.setItem('authToken', accessToken);
    }
    return accessToken;
  }

  validateToken(tokenFromUrl: string): boolean {
    if (this.browserCheck.isBrowser()) {
      const storedToken = sessionStorage.getItem('authToken');
      if (tokenFromUrl && storedToken && tokenFromUrl === storedToken) {
        sessionStorage.removeItem('authToken');
        localStorage.setItem('isLoggedIn', 'true');
        return true;
      }
      this.router.navigate(['/']);
      return false;
    }
    return false;
  }

  redirectToLogin(returnUrl: string = ''): void {
    if (this.browserCheck.isBrowser()) {
      const accessToken = this.generateToken();
      const loginUrl =
        COMMON_CONSTANTS.ACTION_LINKS_LOGIN +
        `?redirectUrl=${encodeURIComponent(returnUrl)}&accessToken=${accessToken}`;
      window.location.href = loginUrl;
    }
  }

  /**
   * To check if a accessToken parameter exists in the URL and validate it
   */
  initializeAuthentication(): void {
    if (this.browserCheck.isBrowser()) {
      const searchParams = new URLSearchParams(window.location.search);
      const tokenFromUrl = searchParams.get('accessToken');
      if (tokenFromUrl) {
        const storedToken = sessionStorage.getItem('authToken');
        if (storedToken && storedToken === tokenFromUrl) {
          localStorage.setItem('isLoggedIn', 'true');
          sessionStorage.removeItem('authToken');
          this.gtmService.dataLayer_Login();
        } else {
          localStorage.setItem('isLoggedIn', 'false');
        }
        searchParams.delete('accessToken');
        const newQueryString = searchParams.toString();
        const newUrl =
          window.location.pathname +
          (newQueryString ? '?' + newQueryString : '');
        window.history.replaceState({}, document.title, newUrl);
      }
    }
  }

  // This function is used to push the logged-in event to the dataLayer
  // for Google Tag Manager (GTM) tracking.
  // It is called when the user successfully logs in.
  dataLayer_Login(): void {
    (window as any).dataLayer.push({
      event: 'login_success',
    });
  }

  // This function will be used to push the signup event to the dataLayer
  // dataLayer_Signup(): void {
  //   (window as any).dataLayer.push({
  //     event: 'signup_success',
  //   });
  // }
}
